import { isClarityProjectConfigured } from '@/config/clarity'
import { clarity } from 'react-microsoft-clarity'

export function canSendClaritySignals(): boolean {
  return isClarityProjectConfigured && clarity.hasStarted()
}

export function sendClarityCustomEvent(eventName: string): void {
  if (!canSendClaritySignals()) {
    return
  }
  clarity.setEvent(eventName)
}
